import PropTypes from 'prop-types';
import { Box } from '@mui/material';
import {
  ArrowBack, Videocam, Call, DoneAll, Send, Check, Close,
} from '@mui/icons-material';
import { brandColors } from '../../constants/brandColors';
import Txt from './Txt';

const BUBBLE_SHADOW = '0 1px .5px rgba(11,20,26,.13)';

/**
 * WhatsPreview — pré-visualização da conversa no chrome de um celular WhatsApp,
 * traduzida 1:1 do componente WhatsPreview da designer. Apenas visual:
 * recebe o texto da mensagem, se mostra os botões Confirmar/Cancelar e se está vazio.
 */
export default function WhatsPreview({ text, showButtons = false, empty = false }) {
  return (
    <Box sx={{ bgcolor: '#0b141a', borderRadius: '26px', p: '10px', boxShadow: '0 12px 34px rgba(11,20,26,.28)', width: '100%', maxWidth: 340, mx: 'auto' }}>
      <Box sx={{ bgcolor: '#e9e0d6', borderRadius: '18px', overflow: 'hidden' }}>
        {/* Header */}
        <Box sx={{ bgcolor: brandColors.whatsapp.header, color: '#fff', display: 'flex', alignItems: 'center', gap: 1.25, px: 1.75, py: '11px' }}>
          <ArrowBack sx={{ fontSize: 22 }} />
          <Box sx={{ width: 34, height: 34, borderRadius: '50%', bgcolor: '#cfd8d3', display: 'flex', alignItems: 'center', justifyContent: 'center', color: brandColors.whatsapp.header, fontWeight: 700, fontSize: 15 }}>M</Box>
          <Box sx={{ lineHeight: 1.2, flex: 1, minWidth: 0 }}>
            <Txt sx={{ fontWeight: 600, fontSize: 14 }}>Maria Silva</Txt>
            <Txt sx={{ fontSize: 11, color: '#bcd6d1' }}>online</Txt>
          </Box>
          <Videocam sx={{ fontSize: 20 }} />
          <Call sx={{ fontSize: 20 }} />
        </Box>

        {/* Corpo do chat */}
        <Box sx={{ bgcolor: brandColors.whatsapp.chatBg, px: 1.5, py: 2, minHeight: 360, display: 'flex', flexDirection: 'column', gap: 1 }}>
          <Box sx={{ alignSelf: 'center', bgcolor: '#d4eaf7', color: '#5a7180', fontSize: 11, px: 1.5, py: '3px', borderRadius: '8px', mb: 0.5 }}>HOJE</Box>

          {/* Balão enviado (negócio) */}
          <Box sx={{ alignSelf: 'flex-end', maxWidth: '86%', bgcolor: brandColors.whatsapp.bubble, borderRadius: '10px', borderTopRightRadius: '3px', px: 1.375, pt: 1, pb: 0.75, boxShadow: BUBBLE_SHADOW }}>
            {empty ? (
              <Txt sx={{ fontSize: 13.5, color: '#9aa6a0', fontStyle: 'italic', whiteSpace: 'pre-wrap', lineHeight: 1.45 }}>
                Sua mensagem aparece aqui conforme você edita ao lado…
              </Txt>
            ) : (
              <Txt sx={{ fontSize: 13.5, color: '#1f2a25', whiteSpace: 'pre-wrap', lineHeight: 1.5 }}>{text}</Txt>
            )}
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', gap: 0.5, mt: 0.5 }}>
              <Txt component="span" sx={{ fontSize: 10.5, color: '#667a72' }}>14:30</Txt>
              <DoneAll sx={{ fontSize: 15, color: '#53bdeb' }} />
            </Box>
          </Box>

          {showButtons && (
            <>
              {/* Botões de resposta rápida */}
              <Box sx={{ alignSelf: 'flex-end', maxWidth: '86%', width: '100%', display: 'flex', flexDirection: 'column', gap: '5px', mt: '2px' }}>
                <Box sx={{ bgcolor: '#fff', borderRadius: '9px', p: '9px', textAlign: 'center', color: brandColors.whatsapp.action, fontWeight: 600, fontSize: 13.5, boxShadow: BUBBLE_SHADOW, display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 0.75 }}>
                  <Check sx={{ fontSize: 17 }} />Confirmar
                </Box>
                <Box sx={{ bgcolor: '#fff', borderRadius: '9px', p: '9px', textAlign: 'center', color: '#d33b3b', fontWeight: 600, fontSize: 13.5, boxShadow: BUBBLE_SHADOW, display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 0.75 }}>
                  <Close sx={{ fontSize: 17 }} />Cancelar
                </Box>
              </Box>
              {/* Resposta do cliente */}
              <Box sx={{ alignSelf: 'flex-start', maxWidth: '80%', bgcolor: '#fff', borderRadius: '10px', borderTopLeftRadius: '3px', px: 1.375, pt: 1, pb: 0.75, boxShadow: BUBBLE_SHADOW, mt: '2px' }}>
                <Txt sx={{ fontSize: 13.5, color: '#1f2a25' }}>Confirmado! ✅ Obrigada 😊</Txt>
                <Txt sx={{ textAlign: 'right', fontSize: 10.5, color: '#90a09a', mt: 0.25 }}>14:32</Txt>
              </Box>
            </>
          )}
        </Box>

        {/* Barra de input */}
        <Box sx={{ bgcolor: '#f0f0f0', display: 'flex', alignItems: 'center', gap: 1, px: 1.25, py: 1 }}>
          <Box sx={{ flex: 1, bgcolor: '#fff', borderRadius: '18px', px: 1.75, py: 1, fontSize: 13, color: '#9aa6a0' }}>Mensagem</Box>
          <Box sx={{ width: 38, height: 38, borderRadius: '50%', bgcolor: brandColors.whatsapp.action, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <Send sx={{ fontSize: 20, color: '#fff' }} />
          </Box>
        </Box>
      </Box>
    </Box>
  );
}

WhatsPreview.propTypes = {
  text: PropTypes.string,
  showButtons: PropTypes.bool,
  empty: PropTypes.bool,
};
